import React from "react";
import { Calendar } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { getTaskPriorityBadgeClass, getTaskStatusBadgeClass } from "../../utils/helpers";

export const VisitTasksDialog = ({ open, onOpenChange, selectedVisit, selectedVisitTasks, studies }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto" data-testid="visit-tasks-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Calendar className="h-5 w-5" />
          Tasks for Visit: {selectedVisit?.patient_name}
        </DialogTitle>
        <DialogDescription>
          {selectedVisit && (
            <div className="space-y-1">
              <p><strong>Study:</strong> {studies.find(s => s.id === selectedVisit.study_id)?.name || 'Unknown Study'}</p>
              <p><strong>Visit Type:</strong> {selectedVisit.visit_type?.replace('_', ' ')?.toUpperCase()}</p>
              <p><strong>Date:</strong> {new Date(selectedVisit.date + 'Z').toLocaleDateString('en-US', { timeZone: 'UTC' })}</p>
              <p><strong>PI:</strong> {selectedVisit.pi_name}</p>
            </div>
          )}
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        {selectedVisitTasks.length > 0 ? (
          <div className="grid gap-4">
            {selectedVisitTasks.map((task) => (
              <Card key={task.id} className="border-l-4 border-l-blue-500">
                <CardContent className="p-4">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <h4 className="font-medium text-gray-900">{task.title}</h4>
                      <p className="text-sm text-gray-600 mt-1">{task.description}</p>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-3 text-sm">
                        <div><span className="font-medium text-gray-500">Assignee:</span><p>{task.assignee || 'Unassigned'}</p></div>
                        <div><span className="font-medium text-gray-500">Priority:</span><span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ml-1 ${getTaskPriorityBadgeClass(task.priority)}`}>{task.priority?.toUpperCase()}</span></div>
                        <div><span className="font-medium text-gray-500">Status:</span><span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ml-1 ${getTaskStatusBadgeClass(task.status)}`}>{task.status?.replace('_', ' ')?.toUpperCase()}</span></div>
                        <div><span className="font-medium text-gray-500">Due Date:</span><p>{new Date(task.sliding_date || task.planned_date).toLocaleDateString()}</p></div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <Calendar className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p>No tasks found for this visit</p>
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>
);
